<div class="carousel-container d-flex position-relative"
     khA11yCarousel
  [khA11yLabel]="'A11Y_CAROUSEL.CAROUSEL' | translate"
     [class.vertical]="isVertical"
     [style.width]="!isVertical && sizeItemsContainer"
     [style.height]="isVertical && sizeItemsContainer"
     #mainContainer>
  <button type="button"
    class="icon-container left-btn d-flex align-items-center justify-content-center cursor"
    [khA11yLabel]="'A11Y_CAROUSEL.PREVIOUS' | translate"
    (click)="moveItemsOnMultipleSteps(false)"
    [style.background-color]="btnColor"
    #leftBtn>
    <kh-img [path]="btnUrl"
      khA11yHidden
      *ngIf="btnUrl"></kh-img>
    <fa-icon [icon]="['fas','angle-left']"
       khA11yHidden
             class="white"
             *ngIf="!btnUrl"></fa-icon>
  </button>
  <div class="content-container" [ngStyle]="{
         'width': !isVertical && sizeItemsContainer,
         'height': isVertical && sizeItemsContainer,
         'padding-top': isVertical ? btnPadding + 'px' : 0,
         'padding-bottom': isVertical ? btnPadding + 'px' : 0,
         'padding-left': !isVertical ? btnPadding + 'px' : 0,
         'padding-right': !isVertical ? btnPadding + 'px' : 0
         }">
    <div class="position-relative content" khA11yAlert="status" #carouselContainer>
      <ng-content></ng-content>
    </div>
  </div>
  <button type="button"
          class="icon-container right-btn d-flex align-items-center justify-content-center cursor"
      [khA11yLabel]="'A11Y_CAROUSEL.NEXT' | translate"
          (click)="moveItemsOnMultipleSteps(true)"
          [style.background-color]="btnColor"
          #rightBtn>
    <kh-img [path]="btnUrl" khA11yHidden *ngIf="btnUrl"></kh-img>
    <fa-icon [icon]="['fas','angle-right']" khA11yHidden class="white" *ngIf="!btnUrl"></fa-icon>
  </button>
</div>
